export const getParseSize = (string: string) => {
  const array = string.split(' ');
  const number = Number(array[0]);

  return number.toFixed(2) + ' MB';
};
